<footer class="pe-5 d-flex align-items-center justify-content-end" [style.marginBottom.px]="marginBottom">
  {{'@Copyright TotalEnergies'}}
</footer>